<template>
	<div class="row">
		<div class=" offset-lg-2 col-lg-8">
			<input type="text" class="todo-input" placeholder="What needs to be done" v-model="input" @keyup="findFilters">

			<div  v-if="input.trim().length != 0" class="varians-ajax">
				<ul>
					<li @click="addFilter(tip)" v-for="(tip, index) in tips" :key="tip.id" >{{ tip.title }}</li>
					<li v-if="tips.length == 0">Няма резултат</li>
				</ul>
			</div>

			<div v-for="(todo, index) in filters" :key="todo.id" class="todo-item">
				<div class="todo-item-left">
					<div  class="todo-item-label" :class="{ completed : todo.completed }">{{ todo.title }}</div>
				</div>

				<div class="remove-item" @click="removeFilter(index)">
					&times;
				</div>
			</div>

			<div class="extra-container">
				<div>{{ remaining }} / {{ limit }} елемент(а) </div>
			</div>


		</div>

	</div>
</template>

<script>
	import axios from 'axios'

	export default {
		name: 'option-product',
		props: {
			filters: {
				type:Array,
				defaut: Array
			},
			limit: {
				type: Number,
				default:100,
			},
			where: {
				type: String,
				require:true
			}
		},
		data () {
			return {
				input:'',
				todos: [],
				tips:[]
			}
		},

		computed: {
			remaining() {
				return this.filters.length
			},

		},

		directives: {
			focus: {
				inserted: function (el) {
					el.focus()
				}
			}
		},

		methods: {
			addFilter(tip) {

				this.input = ''

				this.tips = []

				if(this.limit == this.filters.length) {
					return
				} 

				this.filters.push({
					id: tip.id,
					title: tip.title,
				})

				this.input = ''

				this.tips = []

				// this.exportList()
			},
			removeFilter(index) {
				this.filters.splice(index, 1)
				this.exportList()
			},
			findFilters() {

				if (this.input.trim().length == 0) {
					return
				}
				axios.post(this.$store.getters.getDomainName+this.where, {
					value: this.input
				})
				.then(response => {

					this.tips = response.data
				})

				.catch(error => {

				})
			},

			exportList() {
				this.$emit('exportList', this.filters)
			}
		}, 
		created() {
			console.log(this.filters)
			console.log(this.filters)
			console.log(this.filters)
			console.log(this.filters)
			console.log(this.filters)
			axios.get(this.$store.getters.getDomainName+'shop/filter')
			.then(response => {

			})

			.catch(error => {

			})

		},
		watch: {

			filters(data) {
				this.filters = data;

			},
		}

	}
</script>

<style >
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css");
.todo-input {
	width: 100%;
	padding: 6px 11px;
	font-size: 13px;
	margin-bottom: 16px;
	border: 1px dotted #ccc;
}
.todo-input:focus {
	outline: 0;
}
.todo-item {
	margin-bottom: 12px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	animation-duration: 0.3s;
}
.remove-item {
	cursor: pointer;
	margin-left: 14px;
	font-size: 23px;
}
.remove-item:hover {
	color: black;
}
.todo-item-left {
	display: flex;
	align-items: center;
}
.todo-item-label {
	padding: 10px;
	border: 1px solid white;
	margin-left: 12px;
}
.todo-item-edit {
	font-size: 24px;
	color: #2c3e50;
	margin-left: 12px;
	width: 100%;
	padding: 10px;
	border: 1px solid #ccc;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.todo-item-edit:focus {
	outline: none;
}
.completed {
	text-decoration: line-through;
	color: grey;
}
.extra-container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 13px;
	border-top: 1px solid lightgrey;
	padding-top: 14px;
	margin-bottom: 14px;
}
button {
	font-size: 14px;
	background-color: white;
	appearance: none;
}
button:hover {
	background: lightgreen;
}
button:focus {
	outline: none;
}
.active {
	background: lightgreen;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.varians-ajax {
	background: #fff;
	border:1px dotted #ddd;
	padding:10px;
	position: absolute;
	width: 95.8%;
}
.varians-ajax ul li {
	cursor:pointer;
	padding: 3px 5px;
	color:#555;
	font-size:16px;
}

</style>


// WEBPACK FOOTER //
// src/components/app_modules/Option.vue